import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";

export const resetModalDialogShownCountMutator: () => void = mutatorAction("resetModalDialogShownCount", (): void => {
    getStore().modalDialogShownCount = 0;
});
